import React from "react";

const ButtonWhiteGold = ({ title, onClick, disabled }) => {
    return (
        <button
            type="submit"
            className={`button md:min-w-36 ${disabled && disabled === true ? "opacity-50" : 'hover:bg-gold-secondary hover:text-white'} text-xs tracking-widest font-bold text-gold-secondary border-2 border-gold-secondary border-opacity-40 rounded-xl p-2`}
            onClick={(e) => {
                onClick(e);
            }}
            disabled={disabled ?? false}>
            {title.toUpperCase()}
        </button>
    );
};

export default ButtonWhiteGold;
